export default __webpack_public_path__ + "static/media/test6.e5104bfe.png";